import React, { Component } from 'react';
import { Input, Icon, Popup, Modal, Segment, Dropdown, Pagination, Grid } from 'semantic-ui-react';
import axios from '../../axios';
import Loader from '../../Shared Components/loader';
import '../../Courses/stylesheets/headerStyles.css';
import {GFG_API} from '../../urls';

const defaultState = {
    isSearchVisible: false,
    googleSearchValue: "",
    open: false,
    searchResults: [],
    searchInformation: [],
    sort: "relevance",
    totalPages: null,
    isSearchLoading: false,
    isSearchInvalid: false,
    currentPage: 1
}

class SearchModal extends Component {
    state = {
       ...defaultState
    }
    
    googleSearch = () => {
        this.setState({ isSearchLoading: true });
        this.setState({ searchResults: [] });
        this.setState({ searchInformation: []})
        axios.post(`${GFG_API}/googlesearch/`, new URLSearchParams({ 
              page: ""+this.state.currentPage,
              sort: this.state.sort,
              type: "practice",
              query: encodeURIComponent(this.state.googleSearchValue)
            }), {
              headers: {
                  'Content-Type': 'application/x-www-form-urlencoded',
              }
        })
        .then((res) => {
            if(res.data.response){
                this.setState({searchResults: res.data.response.items ? res.data.response.items : []});
                this.setState({ searchInformation: res.data.response.searchInformation });
                let totalCount = Number(res.data.response.searchInformation.totalResults);
                totalCount = Math.ceil(totalCount/10);
                this.setState({ totalPages: totalCount });
                this.setState({ isSearchLoading: false });
            }
        })
        .catch((err) => {
            this.setState({ isSearchLoading: false });
            alert(err);
            console.log(err);
        })
      }

    handleEnter = (e) => {
        if(e.key === 'Enter'){
            this.setState({open: true});
            if(this.state.googleSearchValue == ""){
                this.setState({isSearchInvalid: true});
                this.setState({open: false});
            } else {
                this.setState({open: true});
                this.googleSearch();
            }
        }
    }
    render() {
        return(
            <>
            {this.state.isSearchVisible && 
                <Popup 
                   content='Input field can not be empty' 
                   open={this.state.isSearchInvalid}
                   onClose={() => {
                       this.setState({isSearchInvalid: false})
                   }}
                   trigger={
                       <Input icon={
                           <Icon name='search' bordered link onClick = {() => {
                                if(this.state.googleSearchValue == ""){
                                    this.setState({isSearchInvalid: true});
                                    this.setState({open: false});
                                } else {
                                    this.setState({open: true});
                                    this.googleSearch();
                                }
                           }}/>
                       } 
                        placeholder='Search...' 
                        onChange={(e, data) => {
                            this.setState({googleSearchValue: data.value})
                        }}
                        onKeyDown={this.handleEnter}
                       />
                   } /> 
               } 
                   <Modal
                       closeIcon={true}
                       className={this.props.customClass}
                       onClose={() => this.setState({...defaultState})}
                       onOpen={() => this.setState({open: true})}
                       open={this.state.open}
                       
                   >
                       {this.state.isSearchLoading && <Loader />}
                       {this.state.isSearchLoading === false && <React.Fragment>
                       { this.state.searchResults &&  this.state.searchResults.length > 0 &&                                                   
                             <div className="parent-sort-by-wrapper">
                                 <p>About {this.state.searchInformation.totalResults} results ({this.state.searchInformation.formattedSearchTime} seconds)</p>
                                <div className="sort-by-wrapper">
                                    <p className="sort-by-search-modal">Sort By</p>
                                         <Dropdown
                                            as="sort_by"
                                            placeholder='Sort By'
                                            selection
                                            value={this.state.sort}
                                            onChange={
                                                (e, data) => {
                                                    this.setState({sort: data.value}, () => {
                                                        this.googleSearch();
                                                    });
                                                }
                                            }
                                            options={
                                                [
                                                    {key: 0, value: "date", text: "Date"},
                                                    {key: 1, value: "relevance", text: "Relevance"}
                                                ]
                                            }
                                        />
                                </div>
                            </div>}
                            
                       </React.Fragment>}
                       { this.state.isSearchLoading === false && this.state.searchResults &&  this.state.searchResults.length ==  0  ?
                            <p className="no-search-result">No Search Results Found</p> :
                        this.state.searchResults.map((item) => (
                               <div>
                                   <Segment className="parent-search">
                                       <a href={item.link}>
                                           <p className="search-title"><u>{item.title}</u></p>
                                           <p className="search-url">{item.formattedUrl}</p>
                                           <p className="search-snippet">
                                               <img src={item.pagemap.cse_image[0].src} className="gfg-search"/>
                                               {item.snippet}
                                           </p>
                                       </a>
                                   </Segment>
                               </div>
                           ))}
                       {!this.state.isSearchLoading && this.state.searchResults.length != 0 && this.props.customClass === "search-modal" && <Pagination
                           defaultActivePage={this.state.currentPage}
                           siblingRange={5}
                           boundaryRange={0}
                           ellipsisItem={null}
                           totalPages={this.state.totalPages}
                           onPageChange={(e, data) => {                           
                               this.setState({ currentPage: data.activePage }, () =>{
                                   this.googleSearch();
                               })
                           }}
                       />}
                       {!this.state.isSearchLoading && this.state.searchResults.length != 0 && this.props.customClass === "search-modal-sm" && <Pagination
                            boundaryRange={0}
                            defaultActivePage={this.state.currentPage}
                            ellipsisItem={null}
                            firstItem={null}
                            lastItem={null}
                            siblingRange={1}
                            totalPages={this.state.totalPages}
                            onPageChange={(e, data) => {
                                this.setState({ currentPage: data.activePage }, () =>{
                                    this.googleSearch();
                                })
                            }}
                       />}
                   </Modal>
                   {this.state.isSearchVisible ? <Icon name='close' bordered link onClick={ 
                        () => {
                            this.setState({isSearchVisible: false, googleSearchValue: ""});
                        }
                    }/>
                    :<Icon name='search' bordered link onClick={ 
                        () => {
                            this.setState({isSearchVisible: true});
                        }
                    }/>} 
                </>
        )
    }
}
export default SearchModal;
